import { Component, OnInit, ViewChild, HostListener } from "@angular/core";
import { CdkConnectedOverlay, CdkOverlayOrigin } from "@angular/cdk/overlay";
import { FieldType } from "@kre-form/core";
import { ActivatedRoute, Params } from "@angular/router";

import * as _ from "lodash";

@Component({
  selector: "kreform-field-inputi18n",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div class="control-design">
        <input nz-input disabled />
      </div>
    </ng-container>

    <ng-template #other>
      <ng-container *ngIf="editor === true">
        <div class="inputi18n">
          <div class="inputi18n-text" cdkOverlayOrigin>
            <input
              nz-input
              autocomplete="off"
              [(ngModel)]="language[0].resValue"
              [kreFormAttributes]="field"
              (ngModelChange)="onChange(language[0].resValue)"
              nz-popover
              nzPopoverTrigger="click"
              [nzPopoverContent]="contentTemplate"
              nzOverlayClassName="inputi18n-template"
              nzPopoverPlacement="bottom"
              [nzOverlayStyle]="{ width: triggerWidth }"
              (nzVisibleChange)="visibleChange($event)"
              [maxLength]="to.maxLength || 200"
              [minLength]="to.minLength || 0"
            />
            <i nz-icon class="inputi18n-i" nzType="global"></i>
          </div>
          <!-- <div class="tips">
            <i
              class="icon-bangzhu"
              [nzTooltipTitle]="tips"
              nzTooltipPlacement="top"
              nz-tooltip
              *ngIf="tips != ''"
            ></i>
          </div> -->
        </div>

        <ng-template #contentTemplate>
          <ul>
            <ng-container *ngFor="let item of language; let i = index">
              <li *ngIf="i > 0">
                <label>{{ item.label }}</label>
                <input
                  nz-input
                  autocomplete="off"
                  [(ngModel)]="item.resValue"
                  [kreFormAttributes]="field"
                  (ngModelChange)="onChange(item.resValue)"
                  [maxLength]="to.maxLength || 200"
                  [minLength]="to.minLength || 0"
                />
              </li>
            </ng-container>
          </ul>
        </ng-template>
      </ng-container>
      <div class="fieldtext" *ngIf="editor === false">{{ langText }}</div>
    </ng-template>
  `,
})
export class KreFormFieldTextI18n extends FieldType implements OnInit {
  constructor(private route: ActivatedRoute) {
    super();
  }

  triggerWidth = "260px";

  @ViewChild(CdkOverlayOrigin, { static: false })
  cdkOverlayOrigin: CdkOverlayOrigin | undefined;
  @HostListener("window:resize", ["$event"])
  resize(event: any) {
    this.visibleChange(event);
  }
  languageList: Array<any> = [
    { languageType: "zh-cn", label: "中", resValue: null },
    { languageType: "en", label: "英", resValue: null },
  ];

  ngOnInit() {
    if (
      !!this.route.snapshot.queryParams["lang"] &&
      (
        this.route.snapshot.queryParams["lang"] as string
      ).toLocaleLowerCase() === "en"
    ) {
      this.languageList = [
        { languageType: "zh-cn", label: "中", resValue: null },
        { languageType: "en", label: "EN", resValue: null },
      ];
    }
  }

  get language() {
    if (
      this.model != undefined &&
      this.model != null &&
      this.key != undefined &&
      this.key != null &&
      this.model.hasOwnProperty(this.key)
    ) {
      if (
        this.formControl.value != undefined &&
        this.formControl.value != null &&
        this.formControl.value != [] &&
        this.formControl.value.length > 0
      ) {
        if (this.formControl.value != this.languageList) {
          this.languageList = this.formControl.value;
        }
      }
    }
    return this.languageList;
  }

  onChange(value: any) {
    if (this.to.required) {
      let empty = this.languageList.some((item: any) => {
        return (
          (item.resValue === null ||
            item.resValue === "" ||
            item.resValue === " ") &&
          item.languageType === "zh-cn"
        );
      });
      if (empty) {
        this.formControl.setValue([]);
      } else {
        this.formControl.setValue(this.languageList);
      }
    } else {
      this.formControl.setValue(this.languageList);
    }
    this.formControl.markAsTouched();
  }

  visibleChange(event: any) {
    if (event) {
      if (this.cdkOverlayOrigin !== undefined) {
        this.triggerWidth =
          this.cdkOverlayOrigin.elementRef.nativeElement.getBoundingClientRect()
            .width -
          0 +
          "px";
      }
    }
  }

  get langText() {
    if (
      this.model != undefined &&
      this.model != null &&
      this.key != undefined &&
      this.key != null &&
      this.model[this.key] != undefined
    ) {
      let lang = this.model[this.key];
      if (
        lang != undefined &&
        lang != null &&
        lang != "" &&
        lang instanceof Array &&
        lang.length > 0
      ) {
        return lang[0]["resValue"];
      }
      return "";
    }
    return "";
  }
}
